<template>
  <div class="d-inline-block align-middle">
    <div class="d-inline-block" >
      <img :src="imageSource" style="height:30px;margin-bottom: 10px"/>
    </div>
    <h5 class="d-inline-block mx-2"><i v-if="iconClass" class="mr-2" :class="iconClass"></i> {{title}}</h5>
    <div class="d-inline-block align-middle" v-show="loading">
      <moon-loader :loading="loading" customClass="moonloaderadjusted" color="#188bf6" size="15px" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'





export default defineComponent({
	name: 'MoonLoaderTitle',
	props: {
    imageSource:String,
    iconClass: String,
		loading: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: '<bind title>',
		},
  },
});
</script>

<style>
  .moonloaderadjusted{
    max-width:50px;
    height:25px;
  }
</style>
